// Meta (Facebook) Pixel loader — mirrors Meta's official snippet, but the
// ~230 KiB fbevents.js download is deferred to window "load" so it never
// competes with the hero image / fonts / app bundle for bandwidth during the
// critical rendering window. The fbq() stub queues calls in the meantime, so
// init/track PageView still fire in order once the real script arrives.
const META_PIXEL_ID = '2314996429237093';

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: unknown;
    };
    _fbq?: unknown;
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.fbq) return; // already loaded — avoid double-injecting the script

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod(...args);
    } else {
      fbq!.queue!.push(args);
    }
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  // Disable Meta's "automatic events" heuristics — without this, fbevents.js scans
  // the page's buttons/links/prices on its own and can auto-fire standard events
  // (like Purchase) just from clicks near price text, with no track() call in our
  // code. Turning it off means ONLY the explicit calls below ever fire.
  window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');

  const loadScript = () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  };

  if (document.readyState === 'complete') {
    loadScript();
  } else {
    window.addEventListener('load', loadScript, { once: true });
  }
}
